/* eslint-disable no-undef */
// Хранение tree представляет собой список вершин с путем до них и дочерним списком файлов.
// Выглядит в виде:
// [ {path: nodePath, childrenNodes: {path: '', filename: '', ...}}, {path: nodePath2, childrenNodes2: {...}}, ... ]
// хранение commitInfo имеет такую же структуру
export default {
  state: {
    tree: {},
    commitsTree: {},
    blobs: {},
    markdownPreviews: {},
    blames: {},
    lastCommitInNodes: {}
  },
  mutations: {
    addNode(state, payload) {
      Vue.set(state.tree, payload?.nodePath, payload?.childrenNodes);
    },
    addCommitInfo(state, payload) {
      Vue.set(state.commitsTree, payload?.nodePath, payload?.commitInfo);
    },
    addBlob(state, payload) {
      Vue.set(state.blobs, payload?.blobPath, payload?.blob);
    },
    addMarkdownPreview(state, payload) {
      Vue.set(state.markdownPreviews, payload?.blobPath, payload?.markdownPreview);
    },
    addBlame(state, payload) {
      Vue.set(state.blames, payload?.blobPath, payload?.blame);
    },
    addLastCommitInNodes(state, payload) {
      Vue.set(state.lastCommitInNodes, payload?.nodePath, payload?.lastCommitInfo);
    }
  },
  actions: {
    addNode(state, payload) {
      state.commit('addNode', payload);
    },
    addCommitInfo(state, payload) {
      state.commit('addCommitInfo', payload);
    },
    addBlob(state, payload) {
      state.commit('addBlob', payload);
    },
    addMarkdownPreview(state, payload) {
      state.commit('addMarkdownPreview', payload);
    },
    addBlame(state, payload) {
      state.commit('addBlame', payload);
    },
    addLastCommitInNodes(state, payload) {
      state.commit('addLastCommitInNodes', payload);
    }
  },
  getters: {
    getNodeChildrenByPath: (state) => (nodePath) => state.tree[nodePath] || null,
    getCommitInfoByPath: (state) => (nodePath) => state.commitsTree[nodePath] || null,
    getBlobByPath: (state) => (blobPath) => state.blobs[blobPath] || null,
    getMarkdownPreviewByPath: (state) => (blobPath) => state.markdownPreviews[blobPath] || null,
    getBlameByPath: (state) => (blobPath) => state.blames[blobPath] || null,
    getLastCommitInNodes: (state) => (nodePath) => state.lastCommitInNodes[nodePath] || null
  }
};
